/**
 * Which routes render without the app navbar.
 *
 * The assistant is a working surface rather than a destination in the site, so it
 * reads better without the logo and Logout sitting above it — matching the modal the
 * same chat opens in. Keeping this in route config means Layout never has to sniff
 * pathnames, and a new bare route is one field rather than a condition.
 */
export type ChromeRoute = { path: string; chrome?: 'bare' };

/** Trailing slashes are incidental; everything else must match the route exactly. */
function normalise(pathname: string): string {
  return pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
}

export function hasBareChrome(pathname: string, routes: ChromeRoute[]): boolean {
  const target = normalise(pathname);
  // Unknown routes keep their chrome: losing the navbar should be opt-in, never a
  // side effect of a typo or a route added without thinking about it.
  return routes.some((route) => normalise(route.path) === target && route.chrome === 'bare');
}
